import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import { TableData } from '../common/components/TableData';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { Helper } from '../common/helpers/Helper';
import { DynamicFormDialog } from '../common/components/DynamicFormDialog';
import * as camJson from '../assets/data/camSettings.json';
import { DialogMsg } from '../common/components/DialogMsg';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppTheme } from '../styles/AppTheme';
import { AppHelper } from '../helpers/AppHelper';

export class Cams extends Component {
  constructor(props) {
    super(props);
    this.formDefinition = null;
    this.slug = this.props.match.params.id ? this.props.match.params.id : null;
    this.state = {
      inProcess: false,
      dialogMsg: false,
      editingItem: null,
      modalOpen: false,
      adminDialog: false,
      dialogAction: '',
      dialogTitle: '',
      name: '',
      urlJpeg: '',
      urlVideo: '',
      streamContentWidth: '',
      streamContentHeight: '',
      flags: '',
      selectedItem: {},
      showDeleteError: false,
      camDelete: '',
      fetchState: ApiHelperV2.State.LOADING,
      formFieldsValidity: {
        name: true,
        urlJpeg: true,
        urlVideo: true,
        streamContentWidth: true,
        streamContentHeight: true,
        flags: true
      },
      formFieldErrMsg: {
        name: '*Required',
        urlJpeg: '*Required',
        urlVideo: '*Required',
        streamContentWidth: '*Required',
        streamContentHeight: '*Required',
        flags: '*Required'
      }
    }
    this.camFields = {
      name: {
        key: 'name',
        label: 'Title',
        type: 'text'
      },
      urlJpeg: {
        key: 'urlJpeg',
        label: 'Camera image url',
        type: 'text'
      },
      urlVideo: {
        key: 'urlVideo',
        label: 'Camera video url',
        type: 'text'
      },
      streamContentWidth: {
        key: 'streamContentWidth',
        label: 'Camera stream content width (pixel)',
        type: 'text'
      },
      streamContentHeight: {
        key: 'streamContentHeight',
        label: 'Camera stream content height (pixel)',
        type: 'text'
      },
      flags: {
        key: 'flags',
        label: 'Camera flags',
        type: 'text'
      },
      camDelete: {
        key: 'camDelete',
        label: 'Type DELETE',
        type: 'text'
      }
    },
    this.navField = [
      {
        link: '/admin',
        title: 'Organisations',
        icon: 'account_balance'
      },
      {
        title: 'Places',
        icon: 'location_city'
      },
    ]
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })
    ApiHelperV2.call(
      { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['cams'], { placeId: this.slug }) },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.setState({
          camData: results[0],
          fetchState: ApiHelperV2.State.READY
        })
      }.bind(this))
  }

  getCamSettingsApiData = (apiData) => {
    return {
      camData: {
        settingsJson: apiData
      }
    }
  }

  settingsDialogClose = () => {
    this.setState({
      modalOpen: false,
      inProcess: false,
      errMsg: '',
      dialogAction: '',
      dialogTitle: '',
      selectedItem: null,
      name: '',
      urlJpeg: '',
      urlVideo: '',
      flags: '',
      streamContentHeight: '',
      streamContentWidth: '',
      showDeleteError: false,
    })
  }

  renderModal = () => {
    return (
      <DynamicFormDialog
        apiMethod={'PUT'}
        apiEndPoint={ApiHelperV2.makeUrlPath(['cams', this.state.editingItem._id])}
        apiData={{}}
        formDefinition={this.formDefinition}
        isOpen={this.state.modalOpen}
        customJsonBody={true}
        getJsonBody={(apiData) => this.getCamSettingsApiData(apiData)}
        onClosed={() => this.settingsDialogClose()}
        onCompleteAction={() => {
          this.settingsDialogClose()
          this.fetchItems()
        }
        }
      >
      </DynamicFormDialog>
    );

  }

  add = () => {
    this.setState({
      adminDialog: true,
      dialogAction: 'add',
      dialogTitle: 'Add camera',
      selectedItem: {},
      name: '',
      urlJpeg: '',
      urlVideo: '',
      flags: '',
      streamContentHeight: '',
      streamContentWidth: '',
    })
  }

  edit = (item) => {
    this.setState({
      adminDialog: true,
      dialogAction: 'edit',
      dialogTitle: 'Edit camera',
      selectedItem: item,
      name: item.name,
      urlJpeg: item.urlJpeg,
      urlVideo: item.urlVideo,
      flags: AppHelper.arrayToCsv(item.flags),
      streamContentHeight: item.streamContentHeight,
      streamContentWidth: item.streamContentWidth,
    })
  }

  delete = (item) => {
    this.setState({
      adminDialog: true,
      dialogAction: 'delete',
      dialogTitle: 'Delete camera',
      selectedItem: item,
      name: item.name,
      urlJpeg: item.urlJpeg,
      urlVideo: item.urlVideo,
      flags: AppHelper.arrayToCsv(item.flags),
      streamContentHeight: item.streamContentHeight,
      streamContentWidth: item.streamContentWidth,
    })
  }

  settingsV2 = (item) => {
    const endpoint = 'http://localhost/external/camSettings.json'
    ApiHelperV2.call(
      { method: 'GET', endPoint: endpoint },
      function (err, camSettings) {
        if (err) {
          this.setState({
            errMsg: Helper.getErrorMsg(err)
          })
          this.setState({ dialogMsg: true })
          return
        }

        if (item.settingsJson) {
          //console.log('settings', item.settingsJson);
          for (const f of camSettings.fields) {
            if (item.settingsJson[f.key] !== undefined) {
              f.value = item.settingsJson[f.key]
            }
          }
        } else {
          for (const f of camSettings.fields) {
            delete f.value
          }
        }

        this.formDefinition = {
          formType: 'add',
          steps: [camSettings]
        }

        this.setState({
          modalOpen: true,
          editingItem: item
        })
      }.bind(this))
  }

  settings = (item) => {
    const camSettings = camJson;
    if (item.settingsJson) {
      //console.log('settings', item.settingsJson);
      for (const f of camSettings.fields) {
        if (item.settingsJson[f.key] !== undefined) {
          f.value = item.settingsJson[f.key]
        }
      }
    } else {
      for (const f of camSettings.fields) {
        delete f.value
      }
    }
    /*const endpoint = '../../../assets/data/camSettings.json'
    //const endpoint = 'http://localhost/external/camSettings.json'
    ApiHelperV2.call(
      { method: 'GET', endPoint: endpoint },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        //console.log(results)
        this.setState({
          //modalOpen: true,
          editingItem: item
        })
      }.bind(this))*/
    //console.log('camJson', camJson)
    this.formDefinition = {
      formType: 'add',
      steps: [camSettings]
    }
    //console.log('formDefinition', this.formDefinition)
    this.setState({
      modalOpen: true,
      editingItem: item
    })
  }

  dialogCloseValidation = () => {
    const formFieldsValidity = this.state.formFieldsValidity;
    formFieldsValidity.name = true;
    formFieldsValidity.urlJpeg = true;
    formFieldsValidity.urlVideo = true;
    formFieldsValidity.streamContentWidth = true;
    formFieldsValidity.streamContentHeight = true;
    formFieldsValidity.flags = true;

    this.setState({
      formFieldsValidity: formFieldsValidity
    });
  }

  dialogClose = () => {
    const apiBody = this.dialogCloseValidation()
    this.setState({
      adminDialog: false,
      inProcess: false,
      errMsg: '',
      dialogAction: '',
      dialogTitle: '',
      selectedItem: null,
      name: '',
      urlJpeg: '',
      urlVideo: '',
      flags: '',
      streamContentHeight: '',
      streamContentWidth: '',
      showDeleteError: false,
    })
  }

  change = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  getFieldErrorMsg = (formFieldKey) => {
    if (this.state.formFieldErrMsg[formFieldKey]) {
      return this.state.formFieldErrMsg[formFieldKey]
    }
    return '*Required'
  }

  generateTextField = (formField, data) => {
    let disabled = ''
    let validity = {};
    validity = this.state.formFieldsValidity;

    if (this.state.dialogAction === 'delete') {
      if (formField.key === 'camDelete') {
        disabled = false
      } else {
        disabled = true
      }
    } else {
      disabled = false
    }

    return (
      <TextField
        id={formField.key}
        label={formField.label}
        name={formField.key}
        className={css(Styles.inputCss)}
        value={data}
        onChange={e => this.change(e)}
        margin='normal'
        type={formField.type}
        helperText={this.state.dialogAction === 'delete' ? '' :
          validity[formField.key] ? '' : this.getFieldErrorMsg(formField.key)}
        error={this.state.dialogAction === 'delete' ? '' : !validity[formField.key]}
        disabled={disabled}
        InputProps={{
          classes: {
            root: css(Styles.textFieldContentInput),
          }
        }}
        InputLabelProps={{
          classes: {
            root: css(Styles.textFieldContent),
            focused: css(Styles.focused),
          }
        }}
      />
    )
  }

  validateFields = () => {
    const item = this.state;
    const formFieldsValidity = this.state.formFieldsValidity;
    if (!item.name || item.name.length === 0) {
      formFieldsValidity.name = false;
    } else {
      formFieldsValidity.name = true;
    }
    if (!item.urlJpeg || item.urlJpeg.length === 0) {
      formFieldsValidity.urlJpeg = false;
    } else {
      formFieldsValidity.urlJpeg = true;
    }
    /*if (!item.urlVideo || item.urlVideo.length === 0) {
      formFieldsValidity.urlVideo = false;
    } else {
      formFieldsValidity.urlVideo = true;
    }*/
    if (!item.streamContentWidth || item.streamContentWidth.length === 0) {
      formFieldsValidity.streamContentWidth = false;
    } else {
      formFieldsValidity.streamContentWidth = true;
    }
    if (!item.streamContentHeight || item.streamContentHeight.length === 0) {
      formFieldsValidity.streamContentHeight = false;
    } else {
      formFieldsValidity.streamContentHeight = true;
    }
    /*if (!item.flags || item.flags.length === 0) {
      formFieldsValidity.flags = false;
    } else {
      formFieldsValidity.flags = true;
    }*/

    this.setState({
      formFieldsValidity: formFieldsValidity
    });

    for (const key in formFieldsValidity) {
      if (formFieldsValidity[key] === false) {
        return false
      }
    }

    const apiBody = {
      name: item.name,
      urlJpeg: item.urlJpeg,
      urlVideo: item.urlVideo,
      streamContentWidth: item.streamContentWidth,
      streamContentHeight: item.streamContentHeight,
      flags: AppHelper.arrayToCsv(item.flags),
    }
    return apiBody;
  }

  dialogMsgClose = () => {
    this.setState({
      dialogMsg: false,
      inProcess: false,
      errMsg: '',
      dialogAction: '',
      dialogTitle: '',
      selectedItem: null,
      name: '',
      urlJpeg: '',
      urlVideo: '',
      flags: '',
      streamContentHeight: '',
      streamContentWidth: '',
      showDeleteError: false,
    })
  }

  submitOrg = (id) => {
    const apiBody = this.validateFields();
    let options = {};
    if (apiBody) {
      this.setState({
        inProcess: true
      })
      if (!id) {
        options = {
          method: 'POST',
          endPoint: ApiHelperV2.makeUrlPath(['cams']),
          jsonBody: {
            camData: {
              name: this.state.name,
              urlJpeg: this.state.urlJpeg,
              urlVideo: this.state.urlVideo,
              flags: this.state.flags,
              streamContentHeight: this.state.streamContentHeight,
              streamContentWidth: this.state.streamContentWidth,
              placeId: this.slug,

            }
          }
        }
      } else {
        options = {
          method: 'PUT',
          endPoint: ApiHelperV2.makeUrlPath(['cams', id]),
          jsonBody: {
            camData: {
              name: this.state.name,
              urlJpeg: this.state.urlJpeg,
              urlVideo: this.state.urlVideo,
              flags: this.state.flags,
              streamContentHeight: this.state.streamContentHeight,
              streamContentWidth: this.state.streamContentWidth,
              placeId: this.slug,
            }
          }
        }
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            errCode: err.respCode,
            inProcess: false,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            name: '',
            urlJpeg: '',
            urlVideo: '',
            flags: '',
            streamContentHeight: '',
            streamContentWidth: '',
          }), () => this.fetchItems());
        }
      }.bind(this))
    }
  }

  deleteOrg = (id) => {
    if (this.state.camDelete === 'DELETE') {
      this.setState({
        inProcess: true
      })
      const options = {
        method: 'DELETE',
        endPoint: ApiHelperV2.makeUrlPath(['cams', id]),
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            errCode: err.respCode,
            inProcess: false,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            name: '',
            urlJpeg: '',
            urlVideo: '',
            flags: '',
            streamContentHeight: '',
            streamContentWidth: '',
            showDeleteError: false,
          }), () => this.fetchItems());
        }
      }.bind(this))
    } else {
      this.setState({ showDeleteError: true })
    }
  }

  renderDialog = (dialogAction, title) => {
    return (
      <Dialog
        onClose={this.dialogClose}
        open={this.state.adminDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>{title}</p>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.generateTextField(this.camFields.name, this.state.name)}
            {this.generateTextField(this.camFields.urlJpeg, this.state.urlJpeg)}
            {this.generateTextField(this.camFields.urlVideo, this.state.urlVideo)}
            {this.generateTextField(this.camFields.streamContentWidth, this.state.streamContentWidth)}
            {this.generateTextField(this.camFields.streamContentHeight, this.state.streamContentHeight)}
            {this.generateTextField(this.camFields.flags, this.state.flags)}
          </div>
          {dialogAction === 'delete' &&
            <div className={css(Styles.fieldsContainer)}>
              {this.generateTextField(this.camFields.camDelete)}
            </div>
          }
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            disabled={this.state.inProcess}
            variant='contained'
            onClick={this.state.dialogAction === 'delete' ? e => this.deleteOrg(this.state.selectedItem._id) :
              e => this.submitOrg(this.state.selectedItem._id)}
            className={css(Styles.actionButton)}>
            {this.state.dialogAction === 'delete' ? 'Delete' : 'Submit'}
            {this.state.inProcess && <CircularProgress color='primary' size={20} className={css(CommonStyles.marginLeft)} />}
          </Button>
          <Button
            variant='contained'
            onClick={() => this.dialogClose()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
        </DialogActions>
        {this.state.showDeleteError && this.state.dialogAction === 'delete' &&
          <p className={css(Styles.deleteMsg)}>*Enter DELETE Correctly</p>
        }
        {this.state.errMsg &&
          <p className={css(Styles.deleteMsg)}>{this.state.errMsg}</p>
        }
      </Dialog>
    );
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div className={css(Styles.navOuterContainer)}>
          {this.navField.map(nav => {
            return (
              this.state.camData &&
              <Link to={{
                pathname: nav.title === 'Places' ? '/admin/orgs/' + this.state.camData.orgId + '/places' :
                  nav.link
              }} className={css(Styles.navLink)} >
                <Icon className={css(Styles.navIcon)} color='secondary' >
                  {nav.icon}
                </Icon>
                <p className={css(Styles.navTitle)}>{nav.title}</p>
              </Link>
            )
          })}
          {this.state.camData &&
            <p className={css(Styles.navSelected)}>{this.state.camData.name}</p>
          }
        </div>
        <TableData
          titleIcon='videocam'
          titleText='CAMERAS'
          columnTitle={['Camera ID', 'Title']}
          tableData={this.state.camData && this.state.camData.cams}
          icons={[
            {
              title: 'settings',
              funcName: 'settingFunction'
            },
            {
              title: 'create',
              funcName: 'editFunction'
            },
            {
              title: 'delete',
              funcName: 'deleteFunction'
            },
          ]}
          addFunction={this.add}
          editFunction={this.edit}
          deleteFunction={this.delete}
          settingFunction={this.settingsV2} //TODO
        //settingFunction={this.settings}
        />
        {this.renderDialog(this.state.dialogAction, this.state.dialogTitle)}
        {this.state.modalOpen ? this.renderModal() : ''}
        <DialogMsg
          dialogClose={this.dialogMsgClose}
          eventDialog={this.state.dialogMsg}
          title='Settings' desc='Please copy the settings file to the required folder' />
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '95%',
  },
  navOuterContainer: {
    display: 'flex',
    marginBottom: 20
  },
  navLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    backgroundColor:AppTheme.secondaryBg,
    marginRight: 10,
    padding: 5
  },
  navIcon: {
    marginRight: 5,
    fontSize: 35
  },
  navTitle: {
    fontWeight: 600,
    fontSize: 18,
    margin: 0
  },
  navSelected: {
    fontWeight: 'bolder',
    fontSize: 20,
    margin: 0,
    marginLeft: 10,
    alignItems: 'center',
    display: 'flex'
  },
  inputCss: {
    margin: '5px 0px 10px 0px',
    flex: 1,
    color: '#757575'
  },
  dialog: {
    minWidth: 500,
    '@media(max-width: 767px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    borderBottom: '2px solid whitesmoke',
    padding: 20,
    backgroundColor: '#303E8A',
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 25,
    margin: 0,
    color: 'white'
  },
  dialogContent: {
    padding: '0px 20px',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  dialogActions: {
    margin: 20,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    marginRight: 5,
    fontSize: 16,
    textTransform: 'unset'
  },
  textFieldContentInput: {
    color: 'black',
    fontWeight: 600,
    ':before': {
      borderBottom: '2px solid #757575',
    },
    ':after': {
      borderBottom: '2px solid #3F51B5',
    },
  },
  textFieldContent: {
    color: '#757575',
  },
  focused: {
    color: '#3F51B5',
    fontWeight: 'bold'
  },
  deleteMsg: {
    margin: 20,
    marginTop: 0,
    fontWeight: 'bold',
    color: 'red',
    fontSize: 15
  },
})



// WEBPACK FOOTER //
// ./src/screens/Cams.js